// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"dc767469","453":"44b4b3a7"}[chunkId] + ".chunk.js";
};